"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var store = require('../../../../../../config/store');
var constants = require('../../../../../../config/constants');
var _require = require('../../commons/httpClient'),
  httpClient = _require.httpClient;
var _require2 = require('../../commons'),
  fetchGiftCards = _require2.fetchGiftCards;
function getGiftCardElements() {
  var elements = {
    giftCardSelect: '#giftCardSelect',
    giftCardUl: '#giftCardUl',
    giftCardContainer: '#giftCardContainer',
    giftCardAddButton: '#giftCardAddButton',
    giftCardCancelContainer: '#giftCardsCancelContainer',
    giftCardCancelButton: '#giftCardCancelButton',
    giftCardSelectContainer: '#giftCardSelectContainer',
    giftCardSelectWrapper: '#giftCardSelectWrapper',
    giftCardsList: '#giftCardsList',
    giftCardsInfoMessageContainer: '#giftCardsInfoMessage',
    cancelMainPaymentGiftCard: '#cancelGiftCardButton',
    giftCardInformation: '#giftCardInformation'
  };
  return Object.fromEntries(Object.entries(elements).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      selector = _ref2[1];
    return [key, document.querySelector(selector)];
  }));
}
function showGiftCardCancelButton(show) {
  var _getGiftCardElements = getGiftCardElements(),
    giftCardCancelContainer = _getGiftCardElements.giftCardCancelContainer;
  giftCardCancelContainer.classList.toggle('invisible', !show);
}
function removeGiftCards() {
  return _removeGiftCards.apply(this, arguments);
}
function _removeGiftCards() {
  _removeGiftCards = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var response, _getGiftCardElements0, giftCardsList, giftCardAddButton, giftCardSelect, giftCardUl, giftCardsInfoMessageContainer, giftCardSelectContainer, cancelMainPaymentGiftCard, giftCardInformation, adyenPartialPaymentsOrder, submitButton, _document$querySelect, _store$componentsObj2, _store$componentsObj3;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return httpClient({
            method: 'POST',
            url: window.cancelPartialPaymentOrderUrl,
            data: {
              csrf_token: $('#adyen-token').val()
            }
          });
        case 2:
          response = _context2.sent;
          _getGiftCardElements0 = getGiftCardElements(), giftCardsList = _getGiftCardElements0.giftCardsList, giftCardAddButton = _getGiftCardElements0.giftCardAddButton, giftCardSelect = _getGiftCardElements0.giftCardSelect, giftCardUl = _getGiftCardElements0.giftCardUl, giftCardsInfoMessageContainer = _getGiftCardElements0.giftCardsInfoMessageContainer, giftCardSelectContainer = _getGiftCardElements0.giftCardSelectContainer, cancelMainPaymentGiftCard = _getGiftCardElements0.cancelMainPaymentGiftCard, giftCardInformation = _getGiftCardElements0.giftCardInformation;
          adyenPartialPaymentsOrder = document.querySelector('#adyenPartialPaymentsOrder');
          submitButton = document.querySelector('button[value="submit-payment"]');
          adyenPartialPaymentsOrder.value = null;
          giftCardsList.innerHTML = '';
          giftCardAddButton.style.display = 'block';
          giftCardSelect.value = null;
          giftCardSelectContainer.classList.add('invisible');
          giftCardSelect.classList.remove('invisible');
          giftCardUl.innerHTML = '';
          cancelMainPaymentGiftCard.classList.add('invisible');
          showGiftCardCancelButton(false);
          giftCardInformation === null || giftCardInformation === void 0 ? void 0 : giftCardInformation.remove();
          giftCardsInfoMessageContainer.innerHTML = '';
          giftCardsInfoMessageContainer.classList.remove('gift-cards-info-message-container');
          if (submitButton) {
            submitButton.disabled = false;
          }
          store.checkout.options.amount = response.amount;
          store.partialPaymentsOrderObj = null;
          store.addedGiftCards = null;
          store.adyenOrderDataCreated = false;
          if (response.resultCode === constants.RECEIVED) {
            (_document$querySelect = document.querySelector('#cancelGiftCardContainer')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.parentNode.remove();
            (_store$componentsObj2 = store.componentsObj) === null || _store$componentsObj2 === void 0 ? void 0 : (_store$componentsObj3 = _store$componentsObj2.giftcard) === null || _store$componentsObj3 === void 0 ? void 0 : _store$componentsObj3.node.unmount('component_giftcard');
          }
          document.dispatchEvent(new Event('checkout:renderPaymentMethod'));
        case 25:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _removeGiftCards.apply(this, arguments);
}
function giftCardBrands() {
  var paymentMethodsResponse = store.checkout.paymentMethodsResponse;
  return paymentMethodsResponse.paymentMethods.filter(function (pm) {
    return pm.type === constants.GIFTCARD;
  });
}
function renderGiftCardSelectForm() {
  var _getGiftCardElements2 = getGiftCardElements(),
    giftCardUl = _getGiftCardElements2.giftCardUl,
    giftCardSelect = _getGiftCardElements2.giftCardSelect;
  if (giftCardUl !== null && giftCardUl !== void 0 && giftCardUl.innerHTML) {
    giftCardSelect.classList.remove('invisible');
    return;
  }
  var imagePath = store.checkoutConfiguration.paymentMethodsResponse.imagePath;
  giftCardBrands().forEach(function (giftCard) {
    var newListItem = document.createElement('li');
    newListItem.dataset.brand = giftCard.brand;
    newListItem.dataset.name = giftCard.name;
    newListItem.dataset.type = giftCard.type;
    var span = document.createElement('span');
    span.textContent = giftCard.name;
    var img = document.createElement('img');
    img.src = "".concat(imagePath).concat(giftCard.brand, ".png");
    img.width = 40;
    img.height = 26;
    newListItem.append(span, img);
    giftCardUl.appendChild(newListItem);
  });
  giftCardSelect.classList.remove('invisible');
}
function attachGiftCardFormListeners() {
  if (store.giftCardComponentListenersAdded) return;
  var _getGiftCardElements3 = getGiftCardElements(),
    giftCardUl = _getGiftCardElements3.giftCardUl,
    giftCardSelect = _getGiftCardElements3.giftCardSelect,
    giftCardContainer = _getGiftCardElements3.giftCardContainer,
    giftCardSelectWrapper = _getGiftCardElements3.giftCardSelectWrapper;
  if (giftCardUl) {
    giftCardUl.addEventListener('click', function (event) {
      var _store$componentsObj;
      if (!event.target.dataset.name) return;
      var selectedGiftCard = {
        name: event.target.dataset.name,
        brand: event.target.dataset.brand,
        type: event.target.dataset.type
      };
      if ((_store$componentsObj = store.componentsObj) !== null && _store$componentsObj !== void 0 && _store$componentsObj.giftcard) {
        store.componentsObj.giftcard.node.unmount('component_giftcard');
      }
      if (!store.partialPaymentsOrderObj) {
        store.partialPaymentsOrderObj = {};
      }
      var newOption = document.createElement('option');
      newOption.textContent = selectedGiftCard.name;
      newOption.value = selectedGiftCard.brand;
      newOption.style.visibility = 'hidden';
      giftCardSelect.appendChild(newOption);
      giftCardSelect.value = selectedGiftCard.brand;
      var giftCardAmount = store.partialPaymentsOrderObj.remainingAmount ? store.partialPaymentsOrderObj.remainingAmount : store.checkout.options.amount;
      giftCardContainer.innerHTML = '';
      var giftCardNode = window.AdyenWeb.createComponent(constants.GIFTCARD, store.checkout, _objectSpread(_objectSpread({}, store.paymentMethodsConfiguration[constants.GIFTCARD]), {}, {
        brand: selectedGiftCard.brand,
        name: selectedGiftCard.name,
        amount: giftCardAmount
      })).mount(giftCardContainer);
      store.componentsObj.giftcard = {
        node: giftCardNode
      };
      giftCardUl.classList.toggle('invisible');
    });
  }
  if (giftCardSelect) {
    giftCardSelectWrapper.addEventListener('mousedown', function () {
      giftCardUl.classList.toggle('invisible');
    });
  }
  store.giftCardComponentListenersAdded = true;
}
function showGiftCardWarningMessage() {
  var orderTotalSummaryEl = document.querySelector('.card-body.order-total-summary');
  if (!orderTotalSummaryEl) return;
  var alertContainer = document.createElement('div');
  alertContainer.id = 'giftCardWarningMessage';
  alertContainer.classList.add('alert', 'alert-warning', 'error-message', 'gift-card-warning-msg');
  alertContainer.role = 'alert';
  var alertContainerP = document.createElement('p');
  alertContainerP.classList.add('error-message-text');
  alertContainerP.textContent = window.giftCardWarningMessage;
  alertContainer.append(alertContainerP);
  orderTotalSummaryEl.appendChild(alertContainer);
}
function attachGiftCardAddButtonListener() {
  var _getGiftCardElements4 = getGiftCardElements(),
    giftCardAddButton = _getGiftCardElements4.giftCardAddButton,
    giftCardSelectContainer = _getGiftCardElements4.giftCardSelectContainer,
    giftCardSelectWrapper = _getGiftCardElements4.giftCardSelectWrapper,
    giftCardSelect = _getGiftCardElements4.giftCardSelect;
  if (!giftCardAddButton) return;
  giftCardAddButton.addEventListener('click', function () {
    renderGiftCardSelectForm();
    attachGiftCardFormListeners();
    var giftCardWarningMessage = document.querySelector('#giftCardWarningMessage');
    if (giftCardWarningMessage) {
      document.querySelector('#giftCardWarningMessage').style.display = 'none';
    }
    giftCardSelect.value = 'null';
    giftCardAddButton.style.display = 'none';
    giftCardSelectContainer.classList.remove('invisible');
    giftCardSelectWrapper.classList.remove('invisible');
  });
}
function attachGiftCardCancelListener() {
  var _getGiftCardElements5 = getGiftCardElements(),
    giftCardCancelButton = _getGiftCardElements5.giftCardCancelButton;
  giftCardCancelButton === null || giftCardCancelButton === void 0 ? void 0 : giftCardCancelButton.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return removeGiftCards();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
}
function removeGiftCardFormListeners() {
  var _getGiftCardElements6 = getGiftCardElements(),
    giftCardUl = _getGiftCardElements6.giftCardUl,
    giftCardSelect = _getGiftCardElements6.giftCardSelect;
  giftCardUl.replaceWith(giftCardUl.cloneNode(true));
  giftCardSelect.replaceWith(giftCardSelect.cloneNode(true));
  store.giftCardComponentListenersAdded = false;
}
function clearGiftCardsContainer() {
  var _getGiftCardElements7 = getGiftCardElements(),
    giftCardsList = _getGiftCardElements7.giftCardsList;
  giftCardsList.innerHTML = '';
}
function renderAddedGiftCard(card) {
  var giftCardData = card.giftCard;
  var imagePath = store.checkoutConfiguration.paymentMethodsResponse.imagePath;
  var _getGiftCardElements8 = getGiftCardElements(),
    giftCardsList = _getGiftCardElements8.giftCardsList,
    giftCardAddButton = _getGiftCardElements8.giftCardAddButton;
  var giftCardDiv = document.createElement('div');
  giftCardDiv.classList.add('gift-card');
  var brandContainer = document.createElement('div');
  brandContainer.classList.add('brand-container');
  var giftCardImg = document.createElement('img');
  var giftCardImgSrc = "".concat(imagePath).concat(giftCardData.brand, ".png");
  giftCardImg.setAttribute('src', giftCardImgSrc);
  giftCardImg.classList.add('gift-card-logo');
  var giftCardNameP = document.createElement('p');
  giftCardNameP.textContent = giftCardData.name;
  brandContainer.appendChild(giftCardImg);
  brandContainer.appendChild(giftCardNameP);
  var giftCardAction = document.createElement('div');
  giftCardAction.classList.add('gift-card-action');
  var brandAndRemoveActionWrapper = document.createElement('div');
  brandAndRemoveActionWrapper.classList.add('wrapper');
  brandAndRemoveActionWrapper.appendChild(brandContainer);
  brandAndRemoveActionWrapper.appendChild(giftCardAction);
  var giftCardAmountDiv = document.createElement('div');
  giftCardAmountDiv.classList.add('wrapper');
  var amountLabel = document.createElement('p');
  amountLabel.textContent = window.deductedBalanceGiftCardResource;
  var amountValue = document.createElement('strong');
  amountValue.textContent = card.discountedAmount ? "-".concat(card.discountedAmount) : '';
  giftCardAmountDiv.appendChild(amountLabel);
  giftCardAmountDiv.appendChild(amountValue);
  giftCardDiv.appendChild(brandAndRemoveActionWrapper);
  giftCardDiv.appendChild(giftCardAmountDiv);
  giftCardsList.appendChild(giftCardDiv);
  giftCardAddButton.style.display = 'block';
  removeGiftCardFormListeners();
}
function createElementsToShowRemainingGiftCardAmount() {
  var renderedRemainingAmountEndSpan = document.getElementById('remainingAmountEndSpan');
  var renderedDiscountedAmountEndSpan = document.getElementById('discountedAmountEndSpan');
  if (renderedRemainingAmountEndSpan && renderedDiscountedAmountEndSpan) {
    renderedRemainingAmountEndSpan.innerText = store.partialPaymentsOrderObj.remainingAmountFormatted;
    renderedDiscountedAmountEndSpan.innerText = store.partialPaymentsOrderObj.totalDiscountedAmount;
    return;
  }
  var pricingContainer = document.querySelector('.card-body.order-total-summary');
  var mainContainer = document.createElement('div');
  mainContainer.id = 'giftCardInformation';
  var createContainer = function createContainer(id, startText, endText) {
    var container = document.createElement('div');
    container.id = id;
    container.classList.add('row', 'grand-total', 'leading-lines');
    var startDiv = document.createElement('div');
    startDiv.classList.add('col-6', 'start-lines');
    var startP = document.createElement('p');
    startP.classList.add('order-receipt-label');
    var startSpan = document.createElement('span');
    startSpan.innerText = startText;
    startP.appendChild(startSpan);
    startDiv.appendChild(startP);
    var endDiv = document.createElement('div');
    endDiv.classList.add('col-6', 'end-lines');
    var endP = document.createElement('p');
    endP.classList.add('text-right');
    var endSpan = document.createElement('span');
    endSpan.innerText = endText;
    if (id === 'remainingAmountContainer') {
      endSpan.id = 'remainingAmountEndSpan';
    } else if (id === 'discountedAmountContainer') {
      endSpan.id = 'discountedAmountEndSpan';
    }
    endP.appendChild(endSpan);
    endDiv.appendChild(endP);
    container.appendChild(startDiv);
    container.appendChild(endDiv);
    return container;
  };
  var remainingAmountContainer = createContainer('remainingAmountContainer', window.remainingAmountGiftCardResource, store.partialPaymentsOrderObj.remainingAmountFormatted);
  var discountedAmountContainer = createContainer('discountedAmountContainer', window.discountedAmountGiftCardResource, store.partialPaymentsOrderObj.totalDiscountedAmount);
  mainContainer.appendChild(discountedAmountContainer);
  mainContainer.appendChild(remainingAmountContainer);
  pricingContainer.appendChild(mainContainer);
}
function showGiftCardInfoMessage() {
  var messageText = store.partialPaymentsOrderObj.message;
  var _getGiftCardElements9 = getGiftCardElements(),
    giftCardsInfoMessageContainer = _getGiftCardElements9.giftCardsInfoMessageContainer;
  giftCardsInfoMessageContainer.innerHTML = '';
  giftCardsInfoMessageContainer.classList.remove('gift-cards-info-message-container');
  if (!messageText) return;
  var giftCardsInfoMessage = document.createElement('div');
  giftCardsInfoMessage.classList.add('adyen-checkout__alert-message', 'adyen-checkout__alert-message--warning');
  giftCardsInfoMessage.setAttribute('role', 'alert');
  var infoMessage = document.createElement('span');
  infoMessage.textContent = messageText;
  giftCardsInfoMessage.appendChild(infoMessage);
  giftCardsInfoMessageContainer.appendChild(giftCardsInfoMessage);
  giftCardsInfoMessageContainer.classList.add('gift-cards-info-message-container');
}
function isCartModified() {
  return _isCartModified.apply(this, arguments);
}
function _isCartModified() {
  _isCartModified = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var response, initialAmount, basketAmount;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return httpClient({
            url: window.getBasketAmountUrl,
            method: 'GET'
          });
        case 2:
          response = _context3.sent;
          if (!response.error) {
            _context3.next = 5;
            break;
          }
          throw new Error(response.message);
        case 5:
          initialAmount = store.addedGiftCards[0].orderAmount;
          basketAmount = response.basketAmount;
          return _context3.abrupt("return", basketAmount.currency !== initialAmount.currency || basketAmount.value !== initialAmount.value);
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _isCartModified.apply(this, arguments);
}
function renderGiftCardLogo(imagePath) {
  var headingImg = document.querySelector('#headingImg');
  if (headingImg) {
    headingImg.src = "".concat(imagePath, "genericgiftcard.png");
  }
}
function applyGiftCards() {
  return _applyGiftCards.apply(this, arguments);
}
function _applyGiftCards() {
  _applyGiftCards = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var now, isPartialPaymentExpired, cartModified, _store$addedGiftCards;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          now = new Date().toISOString();
          isPartialPaymentExpired = store.addedGiftCards.some(function (cart) {
            return now > cart.expiresAt;
          });
          _context4.next = 4;
          return isCartModified();
        case 4:
          cartModified = _context4.sent;
          if (!isPartialPaymentExpired) {
            _context4.next = 10;
            break;
          }
          _context4.next = 8;
          return removeGiftCards();
        case 8:
          _context4.next = 23;
          break;
        case 10:
          if (!cartModified) {
            _context4.next = 16;
            break;
          }
          _context4.next = 13;
          return removeGiftCards();
        case 13:
          showGiftCardWarningMessage();
          _context4.next = 23;
          break;
        case 16:
          clearGiftCardsContainer();
          store.addedGiftCards.forEach(function (card) {
            renderAddedGiftCard(card);
          });
          if ((_store$addedGiftCards = store.addedGiftCards) !== null && _store$addedGiftCards !== void 0 && _store$addedGiftCards.length) {
            showGiftCardInfoMessage();
          }
          store.checkout.options.amount = store.addedGiftCards[store.addedGiftCards.length - 1].remainingAmount;
          showGiftCardCancelButton(true);
          attachGiftCardCancelListener();
          createElementsToShowRemainingGiftCardAmount();
        case 23:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _applyGiftCards.apply(this, arguments);
}
function renderGiftCards(_x) {
  return _renderGiftCards.apply(this, arguments);
}
function _renderGiftCards() {
  _renderGiftCards = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(paymentMethodsResponse) {
    var _store$addedGiftCards2;
    var giftCardsData, totalDiscountedAmount, giftCards, lastGiftCard;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fetchGiftCards();
        case 2:
          giftCardsData = _context5.sent;
          totalDiscountedAmount = giftCardsData.totalDiscountedAmount, giftCards = giftCardsData.giftCards;
          if (giftCards !== null && giftCards !== void 0 && giftCards.length) {
            store.addedGiftCards = giftCards;
            lastGiftCard = store.addedGiftCards[store.addedGiftCards.length - 1];
            store.partialPaymentsOrderObj = _objectSpread(_objectSpread({}, lastGiftCard), {}, {
              totalDiscountedAmount: totalDiscountedAmount
            });
          }
          renderGiftCardLogo(paymentMethodsResponse.imagePath);
          if (!((_store$addedGiftCards2 = store.addedGiftCards) !== null && _store$addedGiftCards2 !== void 0 && _store$addedGiftCards2.length)) {
            _context5.next = 9;
            break;
          }
          _context5.next = 9;
          return applyGiftCards();
        case 9:
          attachGiftCardAddButtonListener();
        case 10:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _renderGiftCards.apply(this, arguments);
}
module.exports = {
  removeGiftCards: removeGiftCards,
  renderAddedGiftCard: renderAddedGiftCard,
  attachGiftCardAddButtonListener: attachGiftCardAddButtonListener,
  getGiftCardElements: getGiftCardElements,
  showGiftCardWarningMessage: showGiftCardWarningMessage,
  createElementsToShowRemainingGiftCardAmount: createElementsToShowRemainingGiftCardAmount,
  renderGiftCardSelectForm: renderGiftCardSelectForm,
  showGiftCardInfoMessage: showGiftCardInfoMessage,
  giftCardBrands: giftCardBrands,
  clearGiftCardsContainer: clearGiftCardsContainer,
  attachGiftCardCancelListener: attachGiftCardCancelListener,
  showGiftCardCancelButton: showGiftCardCancelButton,
  applyGiftCards: applyGiftCards,
  renderGiftCardLogo: renderGiftCardLogo,
  isCartModified: isCartModified,
  renderGiftCards: renderGiftCards
};